<template>
  <div>
    <div v-if="bigImages.length > 0" class="images-block">
      <img
        v-for="({ src, alt }, index) in bigImages"
        :key="index"
        :src="src"
        :alt="alt"
        :style="calcStyle(alt)"
        @load="onImgLoad($event, alt)"
      />
    </div>
    <div v-if="smallImages.length > 0" class="images-block-small">
      <img v-for="({ src, alt }, index) in smallImages" :key="index" :src="src" :alt="alt" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      loadedCount: 0,
      exteriorImage: {
        width: 0,
        height: 0,
        relativeWidth: 50,
      },
      interiorImage: {
        width: 0,
        height: 0,
        relativeWidth: 50,
      },
    }
  },
  computed: {
    ...mapState('configuration', ['images']),
    convertedImagesIntoArray() {
      return Object.entries(this.images).reduce((acc, [key, value]) => {
        if (value !== null && value !== '') {
          acc.push({
            src: value,
            alt: key,
          })
        }
        return acc
      }, [])
    },
    bigImages() {
      return this.convertedImagesIntoArray.filter(
        (img) => (img.alt === 'interior' || img.alt === 'exterior') && !!img.src
      )
    },
    smallImages() {
      return this.convertedImagesIntoArray.filter(
        (img) => img.alt !== 'interior' && img.alt !== 'exterior' && !!img.src
      )
    },
  },
  methods: {
    calcStyle(alt) {
      return {
        width: this.calcWidth(alt),
      }
    },
    calcWidth(alt) {
      return (
        (alt === 'interior' ? this.interiorImage.relativeWidth : this.exteriorImage.relativeWidth) +
        '%'
      )
    },
    onImgLoad(event, imageType) {
      this.loadedCount++
      const currentImage = event.target

      if (currentImage) {
        const image = imageType === 'exterior' ? this.exteriorImage : this.interiorImage
        image.width = currentImage.naturalWidth
        image.height = currentImage.naturalHeight
      }

      if (this.loadedCount === 2) {
        this.resizeImages()
      }
    },
    resizeImages() {
      let heightRatio = this.exteriorImage.height / (this.interiorImage.height + 1)
      let normalizedWidth = this.exteriorImage.width / heightRatio
      let proportion = normalizedWidth / (normalizedWidth + this.interiorImage.width)
      this.exteriorImage.relativeWidth = proportion * 100
      this.interiorImage.relativeWidth = (1 - proportion) * 100
    },
  },
}
</script>

<style lang="scss" scoped>
.images-block {
  display: flex;
  justify-content: center;
}

.images-block-small {
  display: flex;
  justify-content: center;
  padding-top: 1em;
  flex-wrap: wrap;

  > img {
    width: 25%;
    transition: transform 0.2s; /* Animation */
  }

  > img:hover {
    z-index: 2;
    transform: scale(2); /* (200% zoom) */
  }
}
</style>
